"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgMicOff = function SvgMicOff(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M20 36a1 1 0 010-2h3v-1.853a15.12 15.12 0 01-2.05-.7A7.997 7.997 0 0116 24v-2a1 1 0 012 0v2.007a6 6 0 003.712 5.59c.6.249 1.155.464 1.677.613a.999.999 0 011.431.217c.852-.011 1.646-.34 2.466-1.177a.997.997 0 01.327-.222l-1.556-1.558a.996.996 0 01-.23.358c-1.144 1.142-1.863.484-3.357-.135A4 4 0 0120 24v-1a1 1 0 01.65-.937l-8.357-8.356a1 1 0 011.414-1.414l22 22a1 1 0 01-1.414 1.414l-5.37-5.37a.997.997 0 01-.209.313c-1.172 1.197-2.394 1.702-3.713 1.742L25 34h3a1 1 0 010 2h-8zm1.999-12.586l.001.585a2 2 0 001.235 1.846c.747.31.606 1.139 1.178.567a.996.996 0 01.356-.229L22 23.413zM31 21a1 1 0 011 1v2a8 8 0 01-.126 1.407 1 1 0 11-1.968-.354c.062-.348.094-.7.094-1.053v-2a1 1 0 011-1zm-6.598-8.983A4 4 0 0128 16v5.34a1 1 0 01-2 0v-5.341a2 2 0 00-3.96-.4 1 1 0 01-1.96-.398 4 4 0 014.322-3.184z",
    id: "mic-off_svg__a"
  }));
};

var _default = SvgMicOff;
exports["default"] = _default;